import React, { useState, useEffect, useRef } from "react";
import * as d3 from "d3";
import { automata, formatter } from './automata'

export function Viz(props) {
  const gRef = useRef(null)

  const [queue, setQueue] = useState([])

  const rule = props.rule

  const seedRow = [...new Array(50)].map(d => {
    const r = Math.random()
    return r < 0.5 ? 0: 1
  })
  // let seedRow = []
  // const leftSeed = [...new Array(50)].map(d => { return 0 })
  // const midSeed = [1]
  // const rightSeed = [...new Array(50)].map(d => { return 0 })
  // seedRow.push(...leftSeed)
  // seedRow.push(...midSeed)
  // seedRow.push(...rightSeed)
  // const seedRow = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
  const nCols = seedRow.length
  const nRows = 25

  const dataGenerator = automata(rule, seedRow, nRows, nCols)

  const width = 100
  const cellSize = width / nCols
  const height = nRows * cellSize + cellSize * 2
  const marginSize = cellSize
  const viewBox = `0 0 ${width} ${height}`
  const gTransform = `translate(${0}, ${marginSize})`
  const step = 800
  const duration = step * 0.9

  // https://bl.ocks.org/mbostock/5649592
  function tweenDash() {
    const l = this.getTotalLength()
    const i = d3.interpolateString(`0,${l}`, `${l},${l}`)
    return (t) => { return i(t); }
  }
  
  useEffect(() => {

    function updateQueue(n, v) {
      queue.push(v)
      for (let i=0; i<queue.length; i++) {
        queue[i].qpos += 1
      }

      if (queue.length > n) {
        queue.shift()
      }
      setQueue(queue)
    }

    function update() {
      const res = dataGenerator.next()
      const datum = res.value
      updateQueue(nRows, datum)
      const data = formatter(queue, rule, cellSize)
      const pathData = data.paths
      const nodeData = data.nodes

      let g = d3.select(gRef.current).selectAll('.g-node').data(queue, d => d.qpos)            
      let t = g.transition().duration(duration)

      g.exit()
        .transition()
        .duration(duration)
        .attr("transform", d => {
          const y = -cellSize
          return `translate(0, ${y})`
        })
        .style("opacity", 0)
        .remove();

      g.merge(g)
        .transition(t)
        .attr("transform", d => {
          const y = nRows * cellSize - (cellSize * d.qpos) - cellSize
          return `translate(0, ${y})`
        })

      const gEnter = g.enter()
        .append('g')
        .attr('class', 'g-node')
        .attr("transform", d => {
          const y = nRows * cellSize
          return `translate(0, ${y})`
        })
        .style('opacity', 0)

      gEnter.selectAll('.node').data(nodeData) 
        .enter()
        .append('circle')
        .attr('class', 'node')
        .attr('cx', d => d.x)
        .attr('cy', cellSize*0.5)
        .attr('r', cellSize/4)
        .style('fill', '#363636')

      gEnter.selectAll('.h-path').data(pathData)
         .enter()
         .append('path')
         .attr('class', 'h-path')
         .attr('d', d => d)
         .style('fill', 'none')
         .style('stroke-linecap', 'round')
         .style('stroke', '#363636')
         .style('stroke-width', '0.3px')

      const gEnterTransition = gEnter.transition().duration(duration)
        .attr("transform", d => {
          const y = nRows * cellSize - cellSize
          return `translate(0, ${y})`
        })
        .style('opacity', 1)
      
      // gEnterTransition.selectAll('.node').style('opacity', 1)
      gEnterTransition.selectAll('.h-path').attrTween("stroke-dasharray", tweenDash) 
    }

    var t = d3.interval((elapsed) => { update() }, step)

    // component will unmount
    return () => { t.stop() }

  }, [rule, queue, cellSize, dataGenerator, duration])

  return (
    <svg width="100%" height="100%" viewBox={viewBox}>
      <g ref={gRef} transform={gTransform}>
      </g>
    </svg>
  )
}
